class SideCartValueProps extends HTMLElement {
    constructor() {
        super();
        const CHECKOUT_BTN_SELECTOR = "#cart-drawer a[href='/checkout']"
        this.cartCheckoutBtn = this.querySelector(CHECKOUT_BTN_SELECTOR);
        this.valuePropsHtml = this.getAttribute("data-value-props");
        this.cartContent = this.querySelector("#cart-drawer div div");


        document.addEventListener("intelligems:loaded", ()=> {
            this.testValuePropsVariant = window.testValuePropsVariant || "orginial-test-variant";
            this.isVPVariant = this.testValuePropsVariant === "valueprops-on-sidecart-variant";
            if(this.isVPVariant && this.cartCheckoutBtn){
                this.renderValueProps();
            }
        });
    }

    connectedCallback() {
        document.addEventListener("intelligems:loaded", ()=> {
            if(this.isVPVariant && this.cartContent){
                const observer = new MutationObserver(() => this.renderValueProps());
                observer.observe(this.cartContent, {       
                    childList: true,
                    subtree: true,
                });
            };
        });
    }

    renderValueProps(){
        try {
            const CHECKOUT_BTN_SELECTOR = "#cart-drawer a[href='/checkout']";
            this.cartCheckoutBtn = document.querySelector(CHECKOUT_BTN_SELECTOR);
            this.valuePropsContent = document.querySelector("#cart-drawer .value-props-content");
            this.secureCheckoutBtn = document.querySelector("#secure-checkout-btn");

            if(!this.cartCheckoutBtn && this.valuePropsContent){
                this.valuePropsContent.remove();
                return;
            }

            if(this.secureCheckoutBtn){
                return;
            }

            const parentOfCheckoutEl = this.cartCheckoutBtn.parentElement;
            const clonedCheckoutBtnEl = this.cartCheckoutBtn.cloneNode(true);
            clonedCheckoutBtnEl.setAttribute("id", "secure-checkout-btn");

            /* Hidding the 'continue shopping' link under the sidecart ATC button */
            const shoppingLink = this.cartCheckoutBtn.nextElementSibling;
            if(shoppingLink){ 
              shoppingLink.style.display = "none";
            };
            
            const checkoutLabel = "Secure Checkout";
            const lockIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 15 24" fill="none" style="margin-right: 5px">
              <g clip-path="url(#clip0_2290_843)">
              <path d="M2.70486 8.37321H2.90486V8.17321C2.90486 6.85586 3.44129 5.59144 4.39781 4.65837C5.35449 3.72515 6.65325 3.2 8.00831 3.2C9.36335 3.2 10.6619 3.72514 11.6186 4.65837C12.5751 5.59144 13.1115 6.85586 13.1115 8.17321V8.37321H13.3115H15.3V17.8H0.7V8.37321H2.70486ZM4.25931 8.16338L4.24898 8.37321H4.45907H11.5655H11.7756L11.7653 8.16338C11.7188 7.22005 11.3021 6.3314 10.6029 5.68131C9.90385 5.03138 8.97609 4.66961 8.01231 4.66961C7.04853 4.66961 6.12077 5.03138 5.42172 5.68131C4.72251 6.3314 4.30577 7.22005 4.25931 8.16338ZM13.9622 9.88431V9.68431H13.7622H2.28682H2.08682V9.88431V16.2809V16.4809H2.28682H13.7622H13.9622V16.2809V9.88431Z" fill="#F3E9E2" stroke="#00263A" stroke-width="0.4"/>
              </g>
              <defs>
              <clipPath id="clip0_2290_843">
              <rect width="15" height="24" fill="white" transform="translate(0.5)"/>
              </clipPath>
              </defs>
              </svg>`;
              clonedCheckoutBtnEl.innerHTML = `<span class="checkout-btn_text">${lockIcon} ${checkoutLabel}</span>`;
              this.cartCheckoutBtn.parentNode.replaceChild(clonedCheckoutBtnEl, this.cartCheckoutBtn);
              this.cartCheckoutBtn.style.display = "none";
        
            /* getting, styling and inserting the content of the 'Value Props' div section  */
            if(!this.valuePropsContent){
                const newValuePropsContainer = document.createElement('div');
                newValuePropsContainer.setAttribute("class", "value-props-content");
                const valuePropsHTML = this.valuePropsHtml;
                newValuePropsContainer.style = `${window.innerWidth <= 768 ? "padding: 10px 0px 10px 10px" : "padding: 16px 0px 16px 10px"}; display:flex; flex-direction: row`;
                newValuePropsContainer.innerHTML = valuePropsHTML;
                /* Adding the 'Value Props' contianer as a sibling of the parentOfCheckoutEl element */
                parentOfCheckoutEl.style.paddingBottom = "0px";
                parentOfCheckoutEl.insertAdjacentElement('afterend', newValuePropsContainer);
            }
          } catch(error) {
            console.error("Error on cart-drawer sidecart value props", error);
            return null;
          }; 
    };
};

customElements.define("sidecart-value-props", SideCartValueProps);